"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCachedFetchAuthorizationToken;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _fetchAuthorizationToken = _interopRequireDefault(require("./fetchAuthorizationToken")); // Based on this article, the token is expected to expire after 10 minutes.
// https://docs.microsoft.com/en-us/azure/cognitive-services/authentication#authenticate-with-an-authentication-token


var TOKEN_EARLY_RENEWAL = 60000;
var TOKEN_EXPIRATION = 600000;

function createCachedFetchAuthorizationToken() {
  var fetchMemoizedAuthorizationToken = (0, _memoizeOne.default)(function (region, subscriptionKey) {
    return (0, _fetchAuthorizationToken.default)({
      region: region,
      subscriptionKey: subscriptionKey
    });
  }, function (_ref, _ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref, 3),
        region = _ref3[0],
        subscriptionKey = _ref3[1],
        now = _ref3[2];

    var _ref4 = (0, _slicedToArray2.default)(_ref2, 3),
        prevRegion = _ref4[0],
        prevSubscriptionKey = _ref4[1],
        prevNow = _ref4[2];

    return region === prevRegion && subscriptionKey === prevSubscriptionKey && now - prevNow < TOKEN_EXPIRATION - TOKEN_EARLY_RENEWAL;
  });
  return function (_ref5) {
    var region = _ref5.region,
        subscriptionKey = _ref5.subscriptionKey;
    return fetchMemoizedAuthorizationToken(region, subscriptionKey, Date.now());
  };
}